import '@/core/http';
import JSONbig from 'json-bigint';
import '@/components/Dialog';
import Vue from 'vue';
import ElementUI from 'element-ui';
// import 'element-ui/lib/theme-chalk/index.css'
import '@/assets/style/index.scss';
import '@/core/mixins/global.js';
import App from './App';
import router from './router';
import store from './store';
import TreeSelect from '@/components/TreeSelect';
import RichEditor from '@/components/RichEditor';
import InputNumberRange from '@/components/InputNumberRange';
import DateRange from '@/components/DateRange';
import FilterBox from '@/components/FilterBox';
import TableProgressColumn from '@/components/TableProgressColumn';
import VCharts from 'v-charts';

import dataV from '@jiaminghi/data-view';
import echarts from 'echarts'
import Icon from 'vue-awesome/components/Icon';
import 'vue-awesome/icons/chart-bar.js';
import 'vue-awesome/icons/chart-area.js';
import 'vue-awesome/icons/chart-pie.js';
import 'vue-awesome/icons/chart-line.js';
import 'vue-awesome/icons/align-left.js';

const Base64 = require('js-base64').Base64

Vue.component('awe-icon', Icon);

Vue.prototype.$echarts = echarts

window.JSON = new JSONbig({storeAsString: true});

Vue.component('tree-select', TreeSelect);
Vue.component('rich-editor', RichEditor);
Vue.component('input-number-range', InputNumberRange);
Vue.component('date-range', DateRange);
Vue.component('filter-box', FilterBox);
Vue.component('table-progress-column', TableProgressColumn);

Vue.use(ElementUI);
Vue.use(VCharts);
// 全局注册
Vue.use(dataV);
Vue.config.productionTip = false;

/* eslint-disable no-new */
new Vue({
  router,
  store,
  Base64,
  render: h => h(App)
}).$mount('#app');
